import Form from "react-bootstrap/Form";
import logo from "../assets/image/logo.png";
import lock from "../assets/image/lock.png";
import eye from "../assets/image/eye.png";
import { useState } from "react";
import eye_off from "../assets/image/eye_off.png";
import Alert from "react-bootstrap/Alert";
import { Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { GetCustomSettingTemplate, signupApi } from "../service/authApi";
import { toast } from "react-toastify";
import SampleSlider from "../widget/Slider/SampleSlider";
import ReactLoading from "react-loading";
import MetaPixel from "../components/MetaPixel";
import Modal from "react-bootstrap/Modal";
import yes from "../assets/image/yes.png";

function CreatePassword() {
  const navigate = useNavigate();
  const [showpassword, setshowPassword] = useState(false);
  const [showpassword1, setshowPassword1] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const location = useLocation();
  const [modalContent, setModalContent] = useState({
    welcomeSignUp: "",
  });
  const [touched, setTouched] = useState({
    password: false,
    confirmPassword: false,
  });
  const formData = location?.state?.formdata;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setTouched({ password: true, confirmPassword: true });
    setLoader(true);
    if (password !== confirmPassword) {
      setError("Passwords do not match");
    } else if (!validatePassword(password)) {
      setError(
        "Password must be at least 8 characters, contain one digit, and one special character."
      );
    } else {
      try {
        setError(null);
        const { phone, ...rest } = formData;
        const data = {
          password: password,
          phonenumber: phone,
          ...rest,
        };

        const response = await signupApi(data);

        if (response?.status) {
          setLoader(false);
          await fetchModalData();
          setShowModal(true);
          // toast.success("User is Created successfully!", {
          //   autoClose: 5000,
          // });
          // setTimeout(() => {
          //   navigate("/");
          // }, 1000);
        }
        // console.log("Password created successfully!");
      } catch (error) {
        console.log(error, "error");
      } finally {
        setTimeout(() => {
          setLoader(false);
        }, 3000);
      }
    }
  };
  const fetchModalData = async () => {
    try {
      setLoader(true);
      const data = await GetCustomSettingTemplate();

      if (data.status) {
        setModalContent({
          welcomeSignUp:
            data.data.welcomeSignUp ||
            "Default body content if API fails to provide.",
        });
      } else {
        setError(data.data.message || "Failed to fetch data");
      }
    } catch (err) {
      setError(err.message || "An error occurred while fetching data");
    } finally {
      setLoader(false);
    }
  };
  const validatePassword = (password) => {
    const passwordRegex =
      /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,}$/;
    return passwordRegex.test(password);
  };

  const isPasswordValid =
    password && confirmPassword && password === confirmPassword && !error;
  const handleClose = () => {
    setShowModal(false);
    navigate("/login");
  };
  const handleShow = () => setShowModal(true);
  return (
    <>
      <MetaPixel />
      <div className="container-fluid bg-white custom-parent">
        <div style={{ minHeight: "100vh" }} className="row custom-row">
          <div className="col-lg-6 ">
            <SampleSlider />
          </div>
          <div className="col-lg-6">
            <div className="login-form">
              {/* <div className="logo"> */}
              {/* <img src={logo} alt="" /> */}{" "}
              <div>
                <h2 className="pricebook" align="center">
                  Price Book
                </h2>
              </div>{" "}
              {/* </div> */}
              <div className="form_text">
                <div className="heading d-flex align-item-center">
                  <span></span>
                  <h1 className="main-heading">Create Password</h1>
                </div>
                <p className="sub-heading mb-4">
                  Your new password must be different from previous used
                  password.
                </p>
                {error && (
                  <Alert variant="danger" className="mb-4">
                    {error}
                  </Alert>
                )}
                <Form onSubmit={handleSubmit}>
                  <div className="form-field">
                    <Form.Group className="mb-3" controlId="password">
                      <div className="position-relative">
                        <img
                          src={lock}
                          alt=""
                          className="left_icon position-absolute"
                        />
                        <Form.Control
                          type={showpassword ? "text" : "password"}
                          placeholder="Password"
                          className={`px-5 ${
                            touched.password &&
                            (error
                              ? "border-danger"
                              : isPasswordValid
                              ? ""
                              : "")
                          }`}
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          onFocus={() =>
                            setTouched((prev) => ({
                              ...prev,
                              password: true,
                            }))
                          }
                        />
                        <img
                          src={showpassword ? eye : eye_off}
                          alt=""
                          className="position-absolute right_icon"
                          onClick={() => setshowPassword(!showpassword)}
                        />
                      </div>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="confirmPassword">
                      <div className="position-relative">
                        <img
                          src={lock}
                          alt=""
                          className="left_icon position-absolute"
                        />
                        <Form.Control
                          type={showpassword1 ? "text" : "password"}
                          placeholder="Confirm Password"
                          className={`px-5 ${
                            touched.confirmPassword &&
                            (error ||
                              (password &&
                                confirmPassword &&
                                password !== confirmPassword))
                              ? "border-danger"
                              : isPasswordValid
                              ? ""
                              : ""
                          }`}
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          onFocus={() =>
                            setTouched((prev) => ({
                              ...prev,
                              confirmPassword: true,
                            }))
                          }
                        />
                        <img
                          src={showpassword1 ? eye : eye_off}
                          alt=""
                          className="position-absolute right_icon"
                          onClick={() => setshowPassword1(!showpassword1)}
                        />
                      </div>
                    </Form.Group>
                    <div className="d-grid gap-2 mb-4">
                      <Button
                        type="submit"
                        className="btn btn-success common-btn"
                        size="lg"
                      >
                        Create
                      </Button>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
        {loader ? (
          <ReactLoading
            type={"bars"}
            color="#33995e"
            height={60}
            width={60}
            className={"globe_loader"}
          />
        ) : (
          ""
        )}
        {showModal ? (
          <>
            <div className="WelcomeModel d-flex justify-content-center align-items-center vh-100">
              <Modal show={showModal} centered className="custom-modal">
                <Modal.Header>
                  <div className="modal-title-container">
                    <Modal.Title>
                      Thank You For Signing Up To Excel Your Revenue!
                    </Modal.Title>
                  </div>
                </Modal.Header>
                <div className="modal-body-container">
                  <Modal.Body>
                    {loader ? (
                      <div>Loading content...</div>
                    ) : error ? (
                      <div className="text-danger">{error}</div>
                    ) : (
                      <div>
                        <div className="d-flex justify-content-center align-items-center yesCont">
                          <img className="yes" src={yes} alt="Thank You" />
                        </div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: modalContent.welcomeSignUp,
                          }}
                        />
                      </div>
                    )}
                  </Modal.Body>
                </div>
                <Modal.Footer>
                  <Button
                    variant=""
                    className="AddUserBtn"
                    onClick={handleClose}
                  >
                    Login
                  </Button>
                </Modal.Footer>
              </Modal>
            </div>
          </>
        ) : (
          ""
        )}
      </div>
    </>
  );
}

export default CreatePassword;
